import { default as addressMessages } from "./Address/messages";
import { default as editableTextMessages } from "./EditableText/messages";
import { default as inlineMessages } from "./inline/messages";
import { messages as mentionsDropdownMessages } from "./richtext/component/mention/MentionsDropdown";

const messages = {
  "ui.selectField.placeholder": "Select",
  "ui.textField.error.limit": "Character limit reached",
  ...inlineMessages,
  ...mentionsDropdownMessages,
  ...editableTextMessages,
  ...addressMessages,
} as const;

export default messages;
